/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { MLDriverVehicleUtil } from 'ml-portals-util-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { MLVehicleInfoLookupService } from 'ml-services-common-react';
import {useAuthentication} from '@xengage/gw-digital-auth-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLAlertGroupComponent, MLPartialVehicleDetailsComponent, MLModifierComponent } from 'ml-components-common-react';
import { MLPublicContactsService } from 'gw-capability-quoteandbind';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import MLPAVehicleGarageLocationComponent from '../MLPAVehicleGarageLocationComponent/MLPAVehicleGarageLocationComponent';
import MLCarcoComponent from '../MLCarcoComponent/MLCarcoComponent';
import { MLPortalStorageService } from 'ml-services-common-react';
import '@xengage/gw-platform-translations';
import metadata from './MLPAAgentEditVehicleComponent.metadata.json5';
import styles from './MLPAAgentEditVehicleComponent.module.scss';
import messages from './MLPAAgentEditVehicleComponent.messages';
import { MLProductCodeUtil } from 'ml-portals-util-js';
import { DateInput } from '@jutro/components/new';
import { MetadataFormContext } from '@jutro/legacy/uiconfig';
import moment from 'moment';
import MLPARegisteredOwnersComponent from '../MLPARegisteredOwnersComponent/MLPARegisteredOwnersComponent'

function MLPAAgentEditVehicleComponent(props) {

    const {
        id = 'mlpaagenteditvehiclecomponent',
        vehicleVM: rawVehicleVM,
        showValidationErrors,
        submissionVM,
        updateModifiers,
        onValidate,
        onVehicleValidityChange,
        isPolicyChange = false,
        isAddOrReplace,
        isEndorsement,
        isNewVehicleTab,
        viewModelService,
        updateWizardData,
        showAltAddressStateError,
        purchaseDateInputError,
        updateViewModel,
        onRegisteredOwnerChange,
        vinErrorCheck,
        updateVinErrorCheck,
        onHasMultipleFarmVehiclesChange,
        hasMultipleFarmVehicles
    } = props;

    const vehicleVM = rawVehicleVM || {};
    if (!vehicleVM.value) {
        vehicleVM.value = vehicleVM.value || {};
    }

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        onValidate: setComponentValidation,
        isComponentValid
    } = useValidation('mlpaagenteditvehiclecomponent');

    const { refreshData } = useDataRefresh();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { EndorsementService } = useDependencies('EndorsementService');
    const translator = useTranslator();

    const isAMP = appConfig.portalCode === 'AMP';
    const isGPA = appConfig.portalCode === 'GPA';
    const VIN_LENGTH = 17;

    const [showOwnedLessThan6Months, setShowOwnedLessThan6Months] = useState(false);
    const [potentialContacts, updatePotentialContacts] = useState([]);
    const [potentialContactsLoading, updatePotentialContactsLoading] = useState(true);
    const [additionalInterestAvailableCandidatesML, setAdditionalInterestAvailableCandidatesML] = useState([]);
    const effectiveDate = _.get(submissionVM, 'baseData.periodStartDate.value', {});
    const isVehicleOfCategory = (category) => {
        return category === _.get(vehicleVM, 'category_ML.value.code', '');
    };
    const vehiclesVMPath = 'lobData.personalAuto.coverables.vehicles';
    const vehicleListValue = _.get(submissionVM, `${vehiclesVMPath}.value`, [])
    const isPrivatePassenger = () => isVehicleOfCategory('private_passenger_light_truck');
    const isOtherPersonallyRegistered = () => isVehicleOfCategory('Other_Personally_Registered');
    const isCollectible = () => isVehicleOfCategory('collectible');
    const isTrailer = () => isVehicleOfCategory('trailer') || isVehicleOfCategory('trailer_np');
    const isTrailerNP = () => isVehicleOfCategory('trailer_np');
    const isCamper = () => isVehicleOfCategory('camper_np')
    const policyAddress = _.get(submissionVM, 'baseData.policyAddress.value', {});
    const isPrivatePassengerNP = () => isVehicleOfCategory('private_passenger_np');
    const isQnB = appConfig.portalCode === 'QB';
    const {authHeader} = useAuthentication();

    const isCostNewVisible = () => (isPrivatePassenger() || isPrivatePassengerNP()) && _.get(vehicleVM, "isCostNewRequired_ML.value") === true && _.get(vehicleVM, "NamedNonOwner_ML.value") !== true;

    const [selectedGarageAddress, setSelectedGarageAddress] = useState();
    const [availableLocations, updateAvailableLocations] = useState([]);
    const [showAddNewAddressSection, setShowAddNewAddressSection] = useState(false);
    const [currentVehicleIndex, setCurrentVehicleIndex] = useState();
    const [farmSelectedVehicles, setFarmSelectedVehicles] = useState([]);
    const [statefarmUseSelectionWarning, setfarmUseSelectionWarning] = useState(false);
    const [stateFarmVehicleTruckError, setFarmVehicleTruckError] = useState(false);
    const [matureDriverDiscountWarning, setMatureDriverDiscountWarning] = useState(false);
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const isModernProductPersonalAuto = isModernProduct && MLProductCodeUtil.isPersonalAuto(_.get(submissionVM, 'baseData.productCode.value'));
    const vehicleType = _.get(vehicleVM, 'type_ML.value.code');
    const FARM_ALLOWED_VEHICLE_TYPES = ['4wd_pickup_np', '2wd_truck_np'];
    const ML_STORAGE_KEY_FARM_SELECTED_VEHICLES = 'FARM_SELECTED_VEHICLES';


    const getPrimaryUseAvailableValues = (vehicleTypeCode) => {
        const baseValues = [
            {
                code: 'pleasure',
                name: {
                    id: 'ml.quoteandbind.pa.agent.editVehicle.pleasure.np',
                    defaultMessage: 'Pleasure'
                }
            },
            {
                code: 'business',
                name: {
                    id: 'ml.quoteandbind.pa.agent.editVehicle.business.np',
                    defaultMessage: 'Business'
                }
            },
            {
                code: 'storage_np',
                name: {
                    id: 'ml.quoteandbind.pa.agent.editVehicle.storage.np',
                    defaultMessage: 'Storage'
                }
            }
        ];

        const isAllowedFarmVehicle = FARM_ALLOWED_VEHICLE_TYPES.includes(vehicleTypeCode);

        if (isModernProductPersonalAuto && isAllowedFarmVehicle) {
            baseValues.push({
                code: 'farm_np',
                name: {
                    id: 'ml.quoteandbind.pa.agent.editVehicle.FarmNP.np',
                    defaultMessage: 'Farm'
                }
            });
        }

        return baseValues;
    };

    const [primaryUseAvailableValues, setPrimaryUseAvailableValues] = useState(
        getPrimaryUseAvailableValues(vehicleType)
    );

   const [primaryUseVehicleError, setPrimaryUseVehicleError] = useState(false);

    const currentYear = new Date().getFullYear();
    const hasYear = () => !!vehicleVM.value.year;
    const isVehicleYearPre1981 = () => hasYear() && vehicleVM.value.year < 1981 && vehicleVM.value.year > 1969;

    const {
        canDisplayAnnualMileage,
        createLookupCompCollRequest
    } = MLDriverVehicleUtil();

    const writeValue = (value, path) => {
        _.set(vehicleVM, path, value);
        refreshData();
        updateWizardData(submissionVM);
    };

    const showPurchaseDateMonths = () => policyAddress.state === 'NY' || policyAddress.state === 'NJ';


    const isWhereParkedRequired = () => isPrivatePassenger() || isCollectible() || isPrivatePassengerNP() || isTrailerNP() || isCamper();
    const isAnnualMileageRecentOrModeled = () => vehicleVM.value.isAnnualMileageRecentOrAutoCheck;
    const setDefaultAmounts = useCallback(() => {
        const valueMlAmount = _.get(vehicleVM, 'value_ML.amount.value', undefined);
        if (_.isUndefined(valueMlAmount)) {
            _.set(vehicleVM, 'value_ML.value', { amount: undefined });
        }

        const costNewAmount = _.get(vehicleVM, 'costNew.amount.value', undefined);
        if (_.isUndefined(costNewAmount)) {
            _.set(vehicleVM, 'costNew.value', { amount: 0 });
        }
    }, [vehicleVM]);

    const isParkedAtPrimaryAddress = useCallback(() => {
        const keys = ['addressLine1', 'addressLine2', 'addressLine3', 'city', 'state', 'postalCode', 'country'];
        return _.isEqual(
            _.pick(_.get(vehicleVM, 'garagingLocation_ML.value'), keys),
            _.pick(policyAddress, keys)
        );
    }, [policyAddress, vehicleVM]);

    const handleInterlockExpirationDate = (value) => {
        if (_.isUndefined(value)) {
            vehicleVM.interLockExpirationDate_Ext = null;
        } else {
            vehicleVM.interLockExpirationDate_Ext = value;
        }
        updateViewModel();
    };

    const getFarmVehicleStorageData = async () => {
        const iD = isAMP || isPolicyChange ? submissionVM.jobID.value : submissionVM.quoteID.value;
        const response = await MLPortalStorageService.retrieve(
            iD, 
            null,
            ML_STORAGE_KEY_FARM_SELECTED_VEHICLES,
            authHeader
        );

        const data = typeof response === 'string'
            ? JSON.parse(response)
            : {
                quoteID: submissionVM.quoteID?.value,
                farmVehicles: []
            };

        return data
    };

    const saveFarmVehicleStorageData = async (data) => {
        const iD = isAMP || isPolicyChange ? submissionVM.jobID.value : submissionVM.quoteID.value;
        await MLPortalStorageService.store(
            iD,
            null,
            ML_STORAGE_KEY_FARM_SELECTED_VEHICLES,
            JSON.stringify(data),
            authHeader
        );
    };

    const clearFarmSelectionForCurrentVehicle = async () => {
        const vehicleFixedId = _.get(vehicleVM, 'fixedId.value');

        const data = await getFarmVehicleStorageData();

        data.farmVehicles = Array.isArray(data.farmVehicles)
            ? data.farmVehicles.filter(
                (vehicle) => String(vehicle.fixedId) !== String(vehicleFixedId)
            )
            : [];

        await saveFarmVehicleStorageData(data);

        return data.farmVehicles;
    };

    const updateFarmSelectedVehicleStorage = async (value) => {
        const vehicleFixedId = _.get(vehicleVM, 'fixedId.value');
        const vehicleTypeCode = _.get(vehicleVM, 'type_ML.value.code');

        const data = await getFarmVehicleStorageData();

        data.farmVehicles = Array.isArray(data.farmVehicles)
            ? data.farmVehicles
            : [];

        if (value?.code === 'farm_np') {
            const alreadyExists = data.farmVehicles.some(
                (vehicle) => String(vehicle.fixedId) === String(vehicleFixedId)
            );

            if (!alreadyExists) {
                data.farmVehicles.push({
                    fixedId: vehicleFixedId,
                    vehicleType: vehicleTypeCode,
                    primaryUse: 'farm_np'
                });
            }
        } else {
            data.farmVehicles = data.farmVehicles.filter(
                (vehicle) => String(vehicle.fixedId) !== String(vehicleFixedId)
            );
        }
        await saveFarmVehicleStorageData(data);

        return data.farmVehicles;
    };

    const handleIgnitionInterlock = (value) => {
        if (!_.isUndefined(value)) {
            if (value.code === 'true') {
                _.set(vehicleVM, 'ignitionInterlockCert_Ext', true);
            } else {
                _.set(vehicleVM, 'ignitionInterlockCert_Ext', false);
                _.set(vehicleVM, 'interLockExpirationDate_Ext', null);
            }
        }

        updateViewModel();
    };

    const checkInterlockExpirationDateContainerVisible = () => {
        if (policyAddress.state === 'MN' && vehicleVM.ignitionInterlockCert_Ext.value) {
            return true;
        }
        return false;
    };

    const isCarcoVisible = () => {
        return policyAddress.state === 'NJ' && (isGPA || isAMP) && _.get(vehicleVM.value, "lastVehicleInspection_ML") !== undefined;
    };

    const checkOwnedLessThanSixMonths = () => {
        if (!vehicleVM.purchaseDate_ML.value) {
            setShowOwnedLessThan6Months(false);
            vehicleVM.ownedLessThan6Months_Ext.value = false;
            return;
        }

        const effectiveMonth = effectiveDate.month + 1;
        const currentYear = new Date().getFullYear();

        if (vehicleVM.purchaseDate_ML.value.year === currentYear - 1) {
            if (effectiveMonth < 6) {
                setShowOwnedLessThan6Months(true);
            } else {
                setShowOwnedLessThan6Months(false);
                vehicleVM.ownedLessThan6Months_Ext.value = false;
            }
        } else if (vehicleVM.purchaseDate_ML.value.year === currentYear) {
            if (effectiveMonth > 6) {
                setShowOwnedLessThan6Months(true);
            } else {
                setShowOwnedLessThan6Months(false);
                vehicleVM.ownedLessThan6Months_Ext.value = true;
            }
        } else {
            setShowOwnedLessThan6Months(false);
            vehicleVM.ownedLessThan6Months_Ext.value = false;
        }
    };

    const isAnnualMileageRequiredByType = () => {
        if(isModernProductPersonalAuto){
            return !!((isPrivatePassengerNP()) && canDisplayAnnualMileage(vehicleVM));
        }
        else{
            return !!((isPrivatePassenger()) && canDisplayAnnualMileage(vehicleVM));
        }

    };

    const getQuoteID = () => {
        return isAMP || isPolicyChange ? submissionVM.jobID.value : submissionVM.quoteID.value;
    };

    const isDisputedVendorMileage = () => {
        return vehicleVM.value.disputedVendorAnnualMileage_Ext;
    };

    const updatePurchaseDate = (value) => {
        // handle string value from purchaseYear dropdown
        if (typeof value === 'string') {
            vehicleVM.purchaseDate_ML.value = {
                year: parseInt(value),
                day: 1
            };
        } else {
            vehicleVM.purchaseDate_ML.value = value
        }
        if (!showPurchaseDateMonths()) {
            checkOwnedLessThanSixMonths();
        }
        refreshData();
        updateWizardData(submissionVM);
    };

    const getCarPurchaseAvailableYears = () => {
        const currentYear = new Date().getUTCFullYear();
        const { oldestCarYear } = appConfig.personalAutoConfig;
        // _.range is not inclusive. Need to add -1 to get correct years
        const yearRange = _.range(currentYear, oldestCarYear - 1);
        const years = yearRange.map(_.toString).map((year) => ({
            code: year,
            name: year
        }));
        return years;
    };

    const sortByCode = (a, b) => {
        if (a.code < b.code) {
            return -1;
        }
        if (a.code > b.code) {
            return 1;
        }
        return 0;
    }

    const getFinanceCatergoryAvailableValues = () => {
        const availableFinanceCategories = [..._.get(vehicleVM, "financeCategory_ML.aspects.availableValues")]
        availableFinanceCategories.sort((sortByCode))
        return availableFinanceCategories.map((type) => {
            return {
                code: type.code,
                name: translator({
                    id: type.name,
                    defaultMessage: type.name
                })
            };
        });
    }


    const lookupCollision = async () => {
        const vehicleYear = vehicleVM.year.value ? vehicleVM.year.value.toString() : null;
        const req = createLookupCompCollRequest(
            vehicleYear,
            _.get(vehicleVM, "makeCode_ML.value"),
            _.get(vehicleVM, "modelCode_ML.value"),
            getQuoteID(),
            _.get(vehicleVM, "type_ML.value.code"),
            _.get(vehicleVM, "category_ML.value.code"),
            _.get(vehicleVM, "comprehensiveSymbol_ML.value"),
            _.get(vehicleVM, "collisionSymbol_ML.value"),
            _.get(vehicleVM, "costNew.value"),
            _.get(vehicleVM, "trim_ML.value")
        );

        showProgressDialog(platformMessages.loading);
        try {
            const vehicleInfo = await MLVehicleInfoLookupService.lookUpCollisionCompSymbol(req, authHeader);

            if (vehicleInfo.comprehensiveSymbol_ML && vehicleInfo.collisionSymbol_ML) {
                _.set(vehicleVM, "comprehensiveSymbol_ML.value", vehicleInfo.comprehensiveSymbol_ML);
                _.set(vehicleVM, "collisionSymbol_ML.value", vehicleInfo.collisionSymbol_ML);
                _.set(vehicleVM, "hasSymbolsFilledByCostNew_Ext.value", true);
            }
        } finally {
            hideProgressDialog();
        }
    };


    const findIndexOfCurrentVehicle = (vehicles, currentVehicleAddressLine1) => {
        const vehicleIndex = vehicles.findIndex(item => item.garagingLocation_ML.addressLine1 === currentVehicleAddressLine1);

        if (vehicleIndex !== -1) {
            setCurrentVehicleIndex(vehicleIndex)
        }
    };

    const removeDuplicates = (arr) => {
        const uniqueSet = new Set();

        return arr.filter(obj => {
            for (const key of Object.keys(obj)) {
                if (obj[key] === undefined) {
                    return false;
                }
            }

            const key = JSON.stringify(obj.name);

            if (!uniqueSet.has(key)) {
                uniqueSet.add(key);

                return true;
            }

            return false;
        });
    }

    useEffect(() => {
        // US832729 Need to manually set the isRequired flag to true
        // This was lost during the move from angular to react
        const isAnnualMileageRequired = _.get(vehicleVM, 'isAnnualMileageRequired_ML.value', undefined);

        if (_.isUndefined(isAnnualMileageRequired)) {
            _.set(vehicleVM, 'isAnnualMileageRequired_ML.value', true);
            _.set(vehicleVM, 'partialVehicleAdditionFlag_Ext.value', false);
        }
    });
    useEffect(() => {
        const checkFarmVehicleState = async () => {
            const vehicleFixedId = _.get(vehicleVM, 'fixedId.value');
            const vehicleTypeCode = _.get(vehicleVM, 'type_ML.value.code');
            const primaryUseCode = _.get(vehicleVM, 'primaryUse.value.code');

            const isFarmSelected = primaryUseCode === 'farm_np';
            const isAllowedFarmVehicle = FARM_ALLOWED_VEHICLE_TYPES.includes(vehicleTypeCode);

            if (isFarmSelected && !isAllowedFarmVehicle) {
                _.set(vehicleVM, 'primaryUse.value', null);

                const farmVehicles = await clearFarmSelectionForCurrentVehicle();

                setfarmUseSelectionWarning(false);
                setPrimaryUseVehicleError(false);
                setFarmVehicleTruckError(false);

                onHasMultipleFarmVehiclesChange?.(farmVehicles.length > 1);

                setPrimaryUseAvailableValues(
                    getPrimaryUseAvailableValues(vehicleTypeCode)
                );

                refreshData();
                updateWizardData(submissionVM);

                return;
            }

            const data = await getFarmVehicleStorageData();

            const isCurrentVehicleFarm = data.farmVehicles.some(
                (vehicle) => String(vehicle.fixedId) === String(vehicleFixedId)
            );

            const hasMultipleFarmVehicles = data.farmVehicles.length > 1;

            setPrimaryUseAvailableValues(
                getPrimaryUseAvailableValues(vehicleTypeCode)
            );

            setfarmUseSelectionWarning(isCurrentVehicleFarm && isFarmSelected);

            setPrimaryUseVehicleError(
                isFarmSelected && isAllowedFarmVehicle && hasMultipleFarmVehicles
            );

            setFarmVehicleTruckError(
                isFarmSelected && !isAllowedFarmVehicle
            );

            onHasMultipleFarmVehiclesChange?.(hasMultipleFarmVehicles);
        };

        checkFarmVehicleState();
    }, [_.get(vehicleVM, 'fixedId.value'), _.get(vehicleVM, 'type_ML.value.code'), _.get(vehicleVM, 'primaryUse.value.code')]);
    
    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id)
        }
    }, [id, onValidate, isComponentValid])

    useEffect(() => {
        if (onVehicleValidityChange) {
            onVehicleValidityChange();
        }
    }, [isComponentValid, onVehicleValidityChange])

    useEffect(() => {
        setDefaultAmounts();

        const financeCategory = _.get(vehicleVM, 'financeCategory_ML.value', undefined);

        if (_.isUndefined(financeCategory)) {
            _.set(vehicleVM, 'financeCategory_ML.value', 'owned');
        }

        const garagingLocation = _.get(vehicleVM, 'garagingLocation_ML.value', undefined);

        if (_.isUndefined(garagingLocation)) {
            _.set(vehicleVM, 'garagingLocation_ML.value', policyAddress);
            _.set(vehicleVM, 'parkedAtPrimary_ML.value', true);
        } else {
            _.set(vehicleVM, 'parkedAtPrimary_ML.value', isParkedAtPrimaryAddress());
        }

        const vehicleGaragingLocations = submissionVM.lobData.personalAuto.coverables.vehicles.value
            .filter(location => location.garagingLocation_ML)
            .map((location, index) => ({
                ...location.garagingLocation_ML,
                "code": `garagingLocation_ML_${index}`,
                "name": `${location.garagingLocation_ML.addressLine1}, ${location.garagingLocation_ML.city}, ${location.garagingLocation_ML.state} ${location.garagingLocation_ML.postalCode}`
            }));

        findIndexOfCurrentVehicle(submissionVM.lobData.personalAuto.coverables.vehicles.value, vehicleVM.garagingLocation_ML.value.addressLine1);

        const allAvailableLocations = [
            ...vehicleGaragingLocations,
            {
                "code": "primaryNamedInsured_ML",
                "name": submissionVM.baseData.primaryNamedInsured_ML.primaryAddress?.displayName.value
            },
            {
                "code": "mailingAddress_ML",
                "name": submissionVM.baseData.mailingAddress_ML.displayName.value
            },
            {
                "code": "policyAddress",
                "name": submissionVM.baseData.policyAddress?.displayName.value
            },
            {
                "code": "priorAddress_Ext",
                "name": submissionVM.baseData.priorAddress_Ext?.displayName.value
            },
            {
                "code": "Add New Address",
                "name": "Add New Address",
            }
        ];

        updateAvailableLocations(removeDuplicates(allAvailableLocations));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (authHeader) {
            MLPublicContactsService.getMortgageeContacts(authHeader).then((data) => {
                updatePotentialContacts(data);
            }).finally(() => updatePotentialContactsLoading(false));

            if (isPolicyChange) {
                EndorsementService.getAdditionalInterestCandidatesML(_.get(submissionVM, 'jobID.value'), authHeader).then((candidates) => {
                    setAdditionalInterestAvailableCandidatesML(candidates);
                });
            } else {
                LoadSaveService.getAdditionalInterestCandidatesML(_.get(submissionVM, 'quoteID.value'), authHeader).then((candidates) => {
                    setAdditionalInterestAvailableCandidatesML(candidates);
                });
            }

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onChangeGarageAddress = (value) => {
        if (value === "primaryNamedInsured_ML") {
            _.set(vehicleVM, 'garagingLocation_ML.value', submissionVM.baseData.primaryNamedInsured_ML.primaryAddress.value);
        } else if (value === "mailingAddress_ML") {
            _.set(vehicleVM, 'garagingLocation_ML.value', submissionVM.baseData.mailingAddress_ML.value);
        } else if (value === "policyAddress") {
            _.set(vehicleVM, 'garagingLocation_ML.value', submissionVM.baseData.policyAddress.value);
        } else if (value === "priorAddress_Ext") {
            _.set(vehicleVM, 'garagingLocation_ML.value', submissionVM.baseData.priorAddress_Ext.value);
        } else if (value.indexOf("garagingLocation_ML") > -1) {
            const newLocation = availableLocations.find((location) => {
                return location.code === value;
            });
            _.set(vehicleVM, 'garagingLocation_ML.value', newLocation);
        }

        setSelectedGarageAddress(value);

        if (value === "Add New Address") {
            setShowAddNewAddressSection(true);
            // Clearing the garagingLocation_ML and setting the coutry to 'US' to avoid becoming undefined on repeated changes 
            _.set(vehicleVM, 'garagingLocation_ML', { country: 'us' });
        } else {
            setShowAddNewAddressSection(false);
        }
        updateWizardData(submissionVM);
    }

    const saveNewGaragingAddress = (value, path) => {
        _.set(vehicleVM, path, value);
        refreshData();
        updateWizardData(submissionVM);
    }

    //Handles changes of the vehicle purchase date input
    const handleDateChange = (e) => {
        _.set(vehicleVM, 'vehiclePurchaseDate.value', e.target.value);
        refreshData();
        updateWizardData(submissionVM);
    }

    const checkDate = (dateValue, noError) => {
        if(!isPolicyChange){
            return !noError
        }
        else{
            const vPurchaseDate = dateValue;
            if (!vPurchaseDate?.day || !vPurchaseDate?.month || !vPurchaseDate?.year) { return true; }
            const selected = new Date(vPurchaseDate?.year, vPurchaseDate?.month - 1, vPurchaseDate?.day);
            const today = new Date();
            const maxDate = new Date();
            maxDate.setDate(today.getDate() + 7);
            if (selected > maxDate) {
                return true;
            }
            const validDate = moment(
                { year: vPurchaseDate.year, month: vPurchaseDate.month - 1, day: vPurchaseDate.day },
                true).isValid();
            if (!validDate) return true;
            return false;
        }
    }

    const financialInterestWriteValue = useCallback((value, path) => {
        path = path.substr(1);
        _.set(vehicleVM, path, value);
        refreshData();
    }, [refreshData, vehicleVM]);

    const isFinancedOrLeased = () => {
        return vehicleVM.value.financeCategory_ML === 'financed' || vehicleVM.value.financeCategory_ML === 'leased';
    };

    const isVendorAnnualMileageRequired = () => {
        return isPrivatePassenger() && !!vehicleVM.vendorAnnualMileage_ML && !!_.get(vehicleVM, 'vendorAnnualMileage_ML.value')
    }

    const handleParkedAtPrimaryField = (value, path) => {
        writeValue(value, path);

        if (value) {
            _.set(vehicleVM, 'garagingLocation_ML.value', policyAddress);
            setSelectedGarageAddress("policyAddress");
        } else {
            const newLocation = availableLocations.find((location) => location.code === `garagingLocation_ML_${currentVehicleIndex}`);

            if (newLocation) {
                _.set(vehicleVM, 'garagingLocation_ML.value', newLocation);
            }

            setSelectedGarageAddress(undefined);
            setShowAddNewAddressSection(false)
        }
    }

    const getLabelNameForPurchasePrice = () => {

        if(isPrivatePassengerNP()){
            return translator(messages.agreedValueAmountLabel);
        }
    }
    const vehiclePurchaseDateValue = _.get(vehicleVM, 'vehiclePurchaseDate.value');

    const drivers = submissionVM?.lobData?.personalAuto?.coverables?.drivers?.value ?? [];
    const saved = _.get(vehicleVM, 'registeredOwners.value', []);

    const initialRegisteredOwners = Array.isArray(saved)
        ? saved.map(s => {
            const id = String(s.driverID ?? s.fixedId);
            const d = drivers.find(dr => String(dr.fixedId) === id);
            if (!d) return null;
            return {
                id,
                label: d.displayFullName_Ext || d.displayName,
            };
        }).filter(Boolean) : [];
    const [registeredOwnersValue, setRegisteredOwnersValue] = useState(initialRegisteredOwners);

    const handleOwnerChange = (selectedOptions) => {
        setRegisteredOwnersValue(selectedOptions);
        const selectedIds = (selectedOptions || []).map(o => String(o.id));
        const selectedDrivers = drivers
            .filter(d => selectedIds.includes(String(d.fixedId)))
            .map(d => ({
                fixedId: d.fixedId,
                displayName: d.displayFullName_Ext || d.displayName,
                driverID: d.fixedId,
            }));
        if (typeof onRegisteredOwnerChange === 'function') {
            onRegisteredOwnerChange(selectedDrivers)
        }
        _.set(vehicleVM, 'registeredOwners.value', selectedDrivers);
        updateWizardData(submissionVM);
    };


    const getCodeValue = (value) => {
        if (_.isString(value)) {
            return value;
        }

        return value?.code || value?.value?.code;
    };

    const setFarmUseField = async (vehicleTypeValue) => {
        const vehicleTypeCode = getCodeValue(vehicleTypeValue);
        const primaryUseCode = _.get(vehicleVM, 'primaryUse.value.code');

        const isFarmSelected = primaryUseCode === 'farm_np';
        const isAllowedFarmVehicle = FARM_ALLOWED_VEHICLE_TYPES.includes(vehicleTypeCode);

        if (isFarmSelected && !isAllowedFarmVehicle) {
            _.set(vehicleVM, 'primaryUse.value', null);

            const farmVehicles = await clearFarmSelectionForCurrentVehicle();

            setfarmUseSelectionWarning(false);
            setPrimaryUseVehicleError(false);
            setFarmVehicleTruckError(false);

            onHasMultipleFarmVehiclesChange?.(farmVehicles.length > 1);

            refreshData();
            updateWizardData(submissionVM);
        }

        setPrimaryUseAvailableValues(getPrimaryUseAvailableValues(vehicleTypeCode));
    };

    const description = `${vehicleVM.value.year} ${vehicleVM.value.make} ${vehicleVM.value.model} ${vehicleVM.value.trim_ML}`;
    const productName = _.get(submissionVM, 'baseData.productName_Ext.value', '');
    let productDisplayName = '';
    if (productName === 'Foremost Auto 5.0' || productName === 'Farmers Auto 5.0') {
        productDisplayName = 'Foremost Home 5.0';

    } else if (productName === 'Farmers Group Auto 5.0') {
         productDisplayName = 'Farmers Group Home 5.0';
    }

    const overrides = {
        farmVehicleTruckErrorDiv: {
            visible: stateFarmVehicleTruckError
        },
        farmUseSelectionErrorDiv: {
            visible: primaryUseVehicleError,
        },
        farmUseSelectionErrorDivStrong: {
            visible: primaryUseVehicleError,
            content: translator(messages.multiFarmVehiclesError, {
                description: description
            })
        },
        imfWarningAlert: {
            visible: statefarmUseSelectionWarning
        },
        farmUseSelectionWarningDiv: {
            visible: statefarmUseSelectionWarning,
            message: translator(messages.farmVehiclesWarning, {
                productname: productDisplayName
            })
        },
        matureDriverDiscountWarningDiv: {
            visible: matureDriverDiscountWarning
        },
        mlPartialVehicleDetailsComponentid: {
            viewModel: vehicleVM,
            submissionVM: submissionVM,
            showProgressDialog,
            hideProgressDialog,
            isCompRaterQuote: !_.isUndefined(submissionVM, "hvqQuoteID_ML.value"),
            onValidate: setComponentValidation,
            updateModifiers,
            showValidationErrors,
            showAdditionalFields: true,
            isPolicyChange,
            isNewVehicleTab,
            viewModelService,
            updateWizardData,
            vinErrorCheck,
            updateVinErrorCheck,
            setFarmUseField
        },
        vehicleFinanceCategoryField: {
            availableValues: getFinanceCatergoryAvailableValues(),
            value: _.get(vehicleVM, 'financeCategory_ML.value.code')
        },
        financialInterestsContainer: {
            visible: !!(isAddOrReplace && isPolicyChange && isFinancedOrLeased())
        },
        financialInterests: {
            model: vehicleVM.additionalInterests,
            onValueChange: financialInterestWriteValue,
            path: "",
            updateViewModel: () => refreshData(),
            initialPotentialContact: potentialContacts,
            showValidationErrors: showValidationErrors,
            onValidate,
            potentialContactsLoading: potentialContactsLoading,
            additionalInterestAvailableCandidatesML
        },
        conditionField: {
            visible: _.get(vehicleVM, 'condition_ML.aspects.required', false),
            value: _.get(vehicleVM, 'condition_ML.value.code')
        },
        agentEndorsementCostNewContainer: {
            visible: isPolicyChange && isCostNewVisible(),
        },
        agentEndorsementCostNewField: {
            visible: isPolicyChange && isCostNewVisible(),
            onBlur: () => {
                const value = _.get(vehicleVM, "costNew.amount.value");
                if (_.isUndefined(value) || _.isNull(value)) {
                    vehicleVM.costNew.amount = undefined;
                } else if ((_.get(vehicleVM, "vin.value.length", 0) !== VIN_LENGTH || !vehicleVM.value.compCollFilledByVinML) && value !== 0) {
                    lookupCollision();
                }
            },
        },
        purchaseYearField: {
            availableValues: getCarPurchaseAvailableYears(),
            value: _.get(vehicleVM, 'purchaseDate_ML.year.value'),
            onValueChange: updatePurchaseDate,
            visible: (!showPurchaseDateMonths() && (isPrivatePassenger() || isCollectible()) && !isModernProductPersonalAuto),
            label: translator(messages.vehiclePurchaseYear)
        },
        // TODO: update to MonthYear picker in Jutro 7.2 (Elysian)
        purchaseDateField: {
            value: _.get(vehicleVM, 'purchaseDate_ML.value'),
            onBlur: updatePurchaseDate,
            visible: (showPurchaseDateMonths() && (isPrivatePassenger() || isCollectible()) && !isModernProductPersonalAuto),
            label: translator(messages.vehiclePurchaseMonth),
            placeholder: "MM/YYYY",
        },
        purchasedLessThan6Months: {
            visible: showOwnedLessThan6Months && !isModernProductPersonalAuto
        },
        vehiclePrimaryUse: {
            className: isQnB ? "radioButtonQnB" : ""
        },
        vehiclePrimaryUseContainer: {
            visible: !isTrailer() && !isOtherPersonallyRegistered() && !isModernProductPersonalAuto
        },
        vehiclePrimaryUseContainerNP: {
            visible: isModernProductPersonalAuto && isPrivatePassengerNP()
        },
        vehiclePrimaryUseNP: {
            visible: isModernProductPersonalAuto && isPrivatePassengerNP(),
            value: _.get(vehicleVM, 'primaryUse.value'),
            availableValues: primaryUseAvailableValues,
            onValueChange: async (value, path) => {
                if (!_.isEmpty(value)) {
                    writeValue(value, path);
                }

                const farmVehicles = await updateFarmSelectedVehicleStorage(value);
                const vehicleFixedId = _.get(vehicleVM, 'fixedId.value');
                const vehicleTypeCode = _.get(vehicleVM, 'type_ML.value.code');

                const isFarmSelected = value?.code === 'farm_np';
                const isAllowedFarmVehicle = FARM_ALLOWED_VEHICLE_TYPES.includes(vehicleTypeCode);

                setfarmUseSelectionWarning(isFarmSelected);
                const hasMultipleFarmVehicles = farmVehicles.length > 1;

                setPrimaryUseVehicleError(
                    isFarmSelected && isAllowedFarmVehicle && hasMultipleFarmVehicles
                );

                setFarmVehicleTruckError(
                    isFarmSelected && !isAllowedFarmVehicle
                );

                onHasMultipleFarmVehiclesChange?.(hasMultipleFarmVehicles);
                const isCurrentVehicleFarm = farmVehicles.some(
                    (vehicle) => vehicle.fixedId === vehicleFixedId
                );
            }
        },
        farmUseTooltipContainer: {
            visible: FARM_ALLOWED_VEHICLE_TYPES.includes(vehicleType),
        },
        vendorAnnualMileageContainer: {
            visible: isVendorAnnualMileageRequired()
        },
        vendorAnnualMileageSpan: {
            content: translator(messages.vendorAnnualMileage, { value: _.get(vehicleVM, 'vendorAnnualMileage_ML.value') })
        },
        annualMileageContainer: {
            visible: isAnnualMileageRequiredByType(),
            disabled: isDisputedVendorMileage()
        },
        annualMileageField: {
            disabled: isAnnualMileageRecentOrModeled() && isModernProductPersonalAuto,
            required: _.get(vehicleVM, 'isAnnualMileageRequired_ML.value', false) && isModernProduct
        },
        parkedAtPrimaryField: {
            label: isTrailer() ? translator(messages.parkedAtPrimaryTrailer) : translator(messages.parkedAtPrimary),
            tooltip: {
                title: translator(messages.tooltipWhatDoesThisMean),
                text: isTrailer() ? translator(messages.parkingTooltipTextTrailer) : translator(messages.parkingTooltipText)
            },
            onValueChange: handleParkedAtPrimaryField
        },
        garageAddressLocation: {
            availableValues: availableLocations,
            value: _.isUndefined(selectedGarageAddress) ? `garagingLocation_ML_${currentVehicleIndex}` : selectedGarageAddress,
            onValueChange: onChangeGarageAddress,
            visible: _.get(vehicleVM, 'parkedAtPrimary_ML.value') === false
        },
        policyAddressContainer: {
            visible: _.get(vehicleVM, 'parkedAtPrimary_ML.value') === false
        },
        addressComponent: {
            onValueChange: saveNewGaragingAddress,
            value: _.get(vehicleVM, 'garagingLocation_ML'),
            initialLockStateCity: false,
            showValidationErrors: showValidationErrors,
            visible: showAddNewAddressSection,
        },
        altGarageStateErrorContainer: {
            visible: showAltAddressStateError,
            role: "alert"
        },
        parkingTypeContainer: {
            visible: !isOtherPersonallyRegistered() && isWhereParkedRequired()
        },
        repairedField: {
            visible: _.get(vehicleVM, 'salvagedTitle_ML.value') === true && !isModernProductPersonalAuto
        },
        vehicleModifiers: {
            modifier: _.get(vehicleVM, 'vehicleModifiers_ML'),
            isVehicleModifiers: true,
            isHomeowners: false,
            modifierIdToAppend: _.get(vehicleVM, 'tempID.value'),
            updateModifier: updateModifiers
        },
        carcoComponent: {
            visible: isCarcoVisible() && isPolicyChange,
            inspectionVM: _.get(vehicleVM, "lastVehicleInspection_ML"),
            onValidate
        },
        ignitionInterlockContainer: {
            visible: policyAddress.state === 'MN'
        },
        ignitionInterlock: {
            value: {
                code: vehicleVM.ignitionInterlockCert_Ext && vehicleVM.ignitionInterlockCert_Ext.value
            },
            onValueChange: (val) => handleIgnitionInterlock(val)
        },
        interlockExpirationDateContainer: {
            visible: checkInterlockExpirationDateContainerVisible()
        },
        interlockExpirationDate: {
            value: _.get(vehicleVM, 'interLockExpirationDate_Ext.value'),
            onValueChange: (val) => handleInterlockExpirationDate(val)
        },
        selectFuelType: {
            visible: isModernProductPersonalAuto && !isTrailer() && !isCamper(),
            disabled:!(_.get(vehicleVM,'isFuelTypeValueEditable.value',false)) 
        },
        purchaseDateInputField: {
            visible: isModernProductPersonalAuto && isPrivatePassengerNP(),
            onChange: handleDateChange,
            value: vehiclePurchaseDateValue,
            stateMessages: {
                error: checkDate(vehiclePurchaseDateValue, purchaseDateInputError) ? [translator(messages.purchaseDateInputErrorMessage)] : []
            },
            onValidate
        },
        purchasePriceField: {
            visible: isModernProductPersonalAuto && isPrivatePassengerNP(),
            label: getLabelNameForPurchasePrice(),
            required: isPrivatePassengerNP() && isVehicleYearPre1981()
        },
        actualCashValueField: {
            visible: isModernProductPersonalAuto && (isTrailer() || isCamper())
        },
        registredOwnersField: {
            visible: isModernProductPersonalAuto && isPrivatePassengerNP(),
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: setComponentValidation
        },
        resolveComponentMap: {
            mlpavehiclegaragelocationcomponent: MLPAVehicleGarageLocationComponent,
            mlpartialvehicledetailcomponent: MLPartialVehicleDetailsComponent,
            mlmodifiercomponent: MLModifierComponent,
            mlCarcocomponent: MLCarcoComponent,
            MLAlertGroupComponent,
            DateInput,
            mlparegisteredOwners: (props) => (
                <MLPARegisteredOwnersComponent
                    {...props}
                    drivers={drivers}
                    registeredOwnersValue={registeredOwnersValue}
                    onChange={handleOwnerChange}
                />
            )
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={vehicleVM}
            classNameMap={styles}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            onValidationChange={setComponentValidation}
            showErrors={showValidationErrors}
            onValueChange={writeValue}
        />
    );
}

MLPAAgentEditVehicleComponent.propTypes = {
    vehicleVM: PropTypes.shape({}).isRequired,
    submissionVM: PropTypes.shape({}).isRequired,
    updateModifiers: PropTypes.func,
    onVehicleValidityChange: PropTypes.func,
    onValidate: PropTypes.func.isRequired,
    updateWizardData: PropTypes.func,
    updateViewModel: PropTypes.func,
    showAltAddressStateError: PropTypes.bool,
    purchaseDateInputError: PropTypes.bool
};

MLPAAgentEditVehicleComponent.defaultProps = {
    updateModifiers: undefined,
    onVehicleValidityChange: undefined,
    updateWizardData: (value) => { },
    updateViewModel: () => { },
    showAltAddressStateError: false,
    purchaseDateInputError: false
};

export default MLPAAgentEditVehicleComponent;
